import {
    combineEpics,
    ofType,
    PledgerEpic,
    PublicKeyCredentialCreationOptionsJSON,
    RegistrationCredentialJSON,
    WebAuthnService
} from "@pledger/frontend-commons";
import {map} from "rxjs/operators";
import {AccountActions} from "./AccountActions";
import {accountWServiceActions} from "../../services/ws/account/accountWServiceActions";
import {webAuthnWServiceActions} from "../../services/ws/webAuthn/webAuthnWServiceActions";
import {mergeMap} from 'rxjs';


/*const emptyEpic : PledgerEpic<any> = (actions$ : Observable<PledgerAction>) => of(AppActions.EMPTY_ACTION.build());*/

const accountLoadedEpic : PledgerEpic<any> = (actions$ ) =>
    actions$.pipe(
        ofType(AccountActions.ACCOUNT_LOADED_ACTION.type),
        map((action) => {
            return accountWServiceActions.GET_USER_PROFILE_ACTION.build();
        })
    );

const startRegistrationSucceededEpic : PledgerEpic<any> = (actions$ ) =>
    actions$.pipe(
        ofType(webAuthnWServiceActions.START_REGISTRATION_SUCCEEDED_ACTION.type),
        mergeMap(async (action,index) => {
            let jsonOptions : PublicKeyCredentialCreationOptionsJSON = action.payload.data;
            let options : PublicKeyCredentialCreationOptions = WebAuthnService.buildPublicKeyCredentialCreationOptions(jsonOptions);
            try {
                let publicKeyCredential = await WebAuthnService.createCredential(options);
                if (publicKeyCredential !== undefined) {
                    let registrationCredentialJSON: RegistrationCredentialJSON = WebAuthnService.buildRegistrationCredentialJSON(publicKeyCredential);
                    return webAuthnWServiceActions.FINISH_REGISTRATION_ACTION.build(jsonOptions.challenge, registrationCredentialJSON);
                }
            }
            catch(error) {
                console.log(error);
            }
            return AccountActions.WEBAUTHN_REGISTRATION_FAILED_ACTION.build();
        })
    );

const finishRegistrationSucceededEpic : PledgerEpic<any> = (actions$ ) =>
    actions$.pipe(
        ofType(webAuthnWServiceActions.FINISH_REGISTRATION_SUCCEEDED_ACTION.type),
        mergeMap(async (action,index) => {
            let success = true;
            if (success) {
                return AccountActions.WEBAUTHN_REGISTRATION_SUCCEEDED_ACTION.build();
            }
            else {
                return AccountActions.WEBAUTHN_REGISTRATION_FAILED_ACTION.build();
            }
        })
    );


const registrationSucceededEpic : PledgerEpic<any> = (actions$ ) =>
    actions$.pipe(
        ofType(AccountActions.WEBAUTHN_REGISTRATION_SUCCEEDED_ACTION.type),
        map((action) => {
            return accountWServiceActions.GET_USER_PROFILE_ACTION.build();
        })
    );

const resetRegistrationSucceededEpic : PledgerEpic<any> = (actions$ ) =>
    actions$.pipe(
        ofType(webAuthnWServiceActions.RESET_REGISTRATION_SUCCEEDED_ACTION.type),
        map((action) => {
            return accountWServiceActions.GET_USER_PROFILE_ACTION.build();
        })
    );

export const accountEpics = combineEpics(
    accountLoadedEpic,
    startRegistrationSucceededEpic,
    finishRegistrationSucceededEpic,
    registrationSucceededEpic,
    resetRegistrationSucceededEpic
);
